import React from "react";
import StarRatings from "react-star-ratings";
import {useTypedSelector} from "../hooks/useTypeSelector";
import {i18n, i18nArray} from "../helpers/localisation-helpers";

interface ProductNavProps {
    sanitisedProductName: string;
}

const ProductNav = (props:ProductNavProps) => {
    const {  productData } = useTypedSelector((state) => state.product);

    if(productData == undefined) {
        return null;
    }
    
    const generateDistanceCalculatorLink = () => {
        let link = "";
        if(productData.ProductBaseType == "Projector") {
            switch(productData.SiteContinent) {
                case "EMEA":
                    link = `/projector-distance-calculator/${props.sanitisedProductName}`;
                    break;
                case "APAC":
                    link = `https://www.optoma.com/projectioncalculator/?name=${productData.ProductName}`;
                    break;
                default:
                    link = `https://www.optoma.com/projectioncalculator/?region=USA&name=${productData.ProductName}`;
                    break;
            }
            
            return (
                <li><a href={link}>{i18n("Resource.DistanceCalculator", productData.PageLocalisations)}</a></li>
            )
        }
    }
    
    const generateAccessoriesLink = () => {
        if(productData.RecommendedProducts != undefined && productData.RecommendedProducts.length > 0) {
        return (
                <li><a href="#accessories">{i18n("Resource.Accessories", productData.PageLocalisations)}</a></li>
            )
        }
    }

    const generateReviewsLink = () => {
        if (productData.ExpertReviews != undefined && productData.ExpertReviews.length > 0) {
            return (
                <li><a href="#reviews">{i18n("Resource.Reviews", productData.PageLocalisations)}</a></li>
            )
        }
    }

    const generateCaseStudiesLink = () => {
        if (productData.CaseStudies != undefined && productData.CaseStudies.length > 0) {
            return (
                <li><a href="#casestudies">{i18n("Resource.CaseStudies", productData.PageLocalisations)}</a></li>
            )
        }
    }
    
    const generateGalleryLink = () => {
        if ((productData.ImageUrls != undefined && productData.ImageUrls.length > 0)
        || productData.Videos != undefined && productData.Videos.length > 0) {

            return (
                <li><a href="#gallery">{i18n("Resource.Gallery", productData.PageLocalisations)}</a></li>
            )
        }
    }
    
    const generateDownloadsLink = () => {
        if(productData.ProductFiles != undefined && productData.ProductFiles.length > 0) {
            return (
                <li><a href="#downloads">{i18n("Resource.Downloads", productData.PageLocalisations)}</a></li>
            )
        }
    }
    
    return (
        <div className="product-nav onepcssgrid-1300">
                <div className="onerow">
                    <nav className="col12 last container">
                        <ul>
                            <li><a href="#features">{i18n("Resource.Features", productData.PageLocalisations)}</a></li>
                            {generateAccessoriesLink()}
                            {generateReviewsLink()}
                            {generateCaseStudiesLink()}
                            {generateGalleryLink()}
                            { productData.ProductName.toLowerCase() !== "optoma management suite" ? (
                                    <li><a href="#specifications">{i18n("Resource.specification", productData.PageLocalisations)}</a></li>
                                ) : ""}
                            {generateDownloadsLink()}
                            {generateDistanceCalculatorLink()}
                        </ul>
                    </nav>
                </div>
        </div>
    )
}

export default ProductNav;